module.exports = DS.Transform.extend({
    serialize: function(date) {
        return date ? date.format('YYYY-MM-DDTHH:mm:ss') : null
    },

    deserialize: function(s) {
        return s ? moment.utc(s) : null
    }
})
